import { render, staticRenderFns } from "./DLoading.vue?vue&type=template&id=1d99b8d8"
import script from "./DLoading.vue?vue&type=script&lang=js"
export * from "./DLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports